"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _isLoggedOut["default"];
  }
});
var _isLoggedOut = _interopRequireDefault(require("./isLoggedOut"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }